import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Stack.module.css';
import StackItem from './components/StackItem';

const bindClasses = classNameBind.bind(styles);

const Stack = ({
  children,
  horizontalAlignment,
  spacing,
  vertical,
  verticalAlignment,
  wrap,
  id,
  fullHeight,
  fullWidth,
  dataId,
}) => {
  const classes = bindClasses(
    'wrapper',
    {
      '-wrap': wrap,
      '-vertical': vertical,
      '-full-height': fullHeight,
      '-full-width': fullWidth,
    },
    `spacing-${spacing}`,
    `horizontal-${horizontalAlignment}`,
    `vertical-${verticalAlignment}`,
  );

  return (
    <div
      id={id}
      className={classes}
      data-ppuc-id={dataId}
    >
      {children}
    </div>
  );
};

Stack.defaultProps = {
  children: null,
  horizontalAlignment: 'left',
  spacing: 'default',
  vertical: false,
  verticalAlignment: 'top',
  wrap: false,
  id: null,
  fullHeight: false,
  fullWidth: false,
  dataId: 'Stack',
};

Stack.Item = StackItem;

export default Stack;
